// src/pages/programs/EditProgram.jsx

import React from "react";
import { useParams, useNavigate } from "react-router-dom";

import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditProgram from "../../components/programs/FormAddEditProgram";
import useGetProgram from "../../hooks/programs/useGetProgram";
import LoadingPage from "../../components/global/LoadingPage";

const EditProgram = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const { isLoading, error, program } = useGetProgram(id);

    if (isLoading) return <LoadingPage />;
    if (error) return null;

    if (program?.closed) {
        return (
            <WrapperSection>
                <GlobalBreadcrumbs />
                <div style={{ textAlign: "center", marginTop: "50px" }}>
                    <h2>عذراً، لا يمكن تعديل هذا البرنامج لأنه مغلق أو تم إصدار فاتورة له.</h2>
                </div>
            </WrapperSection>
        );
    }

    const handleSuccess = () => {
        navigate("/programs");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditProgram
                isEdit={true}
                currentData={program}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default EditProgram;
